module.exports = __webpack_public_path__ + "static/images/line-l.b8a9443.png";